import React, { useEffect, useState } from 'react';

import { Box, Progress, Text, VStack } from '@betterment/samba-react';

type Props = {
  accountRecommendationOption: unknown;
  children: React.ReactNode;
};

export const AccountRecommendationLoadingWrapper: React.FC<Props> = ({ accountRecommendationOption, children }) => {
  const [progress, setProgress] = useState(0);
  const [hasFinishedFakeProgress, setHasFinishedFakeProgress] = useState(false);
  const [shouldShowChildren, setShouldShowChildren] = useState(false);
  const hasDataArrived = accountRecommendationOption !== null && accountRecommendationOption !== undefined;
  const hasDataArrivedAndFinishedFakeProgress = hasDataArrived && hasFinishedFakeProgress;

  useEffect(() => {
    const timeouts = [
      setTimeout(() => setProgress(20), 1),
      setTimeout(() => setProgress(40), 660),
      setTimeout(() => setProgress(60), 1320),
      setTimeout(() => setHasFinishedFakeProgress(true), 1980),
    ];

    return () => timeouts.forEach(t => clearTimeout(t));
  }, []);

  useEffect(() => {
    if (!hasDataArrivedAndFinishedFakeProgress) {
      return undefined;
    }

    setProgress(100);
    const timeout = setTimeout(() => setShouldShowChildren(true), 660);

    return () => clearTimeout(timeout);
  }, [hasDataArrivedAndFinishedFakeProgress]);

  if (shouldShowChildren) {
    return <>{children}</>;
  }

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: 'space.400',
      }}
    >
      <VStack css={{ gap: 'space.300', alignItems: 'center', width: '100%', maxWidth: '500px' }}>
        <Text variant="text100" color="text" css={{ fontSize: 16, textAlign: 'center' }}>
          Reviewing your financial profile and accounts
        </Text>
        <Box css={{ width: '100%', height: '8px' }}>
          <Progress value={progress} indicatorColor="background.info.strong" />
        </Box>
      </VStack>
    </Box>
  );
};
